

let Power={
  NONE : 0, //没有
  //终端设备管理
  TERMINAL_ADMIN   : 1,  //
  TERMINAL_MANAGER : 2,  //终端所有权限
  TERMINAL_SELF    : 4,  //终端自己权限
//用户
  USER_ADMIN       : 8  ,//用户的所有权限
  USER_MANAGER     : 16 ,//用户自己的权限
  USER_SELF        : 32 ,//
 //数据分析
  DATA_ADMIN       : 64     ,
  DATA_MANAGER     : 128    ,
  DATA_SELF        : 256    ,
//医疗单位
  COMPANY_ADMIN    : 512    ,
  COMPANY_MANAGER  : 1024   ,
//医废管理
  MW_ADMIN         : 2048   ,
  MW_MANAGER       : 4096   ,
  MW_SELF          : 8192   ,
//我的投放点                    
  MY_TERMINAL      : 16384  ,

  //门卫
  GUARD:32768,

};

export default Power



// WEBPACK FOOTER //
// ./src/view/power.js